export default "__VITE_ASSET__6sBZq_7Y__"